import UserInfo from '../common/types/UserInfo';
import LanguageSlice from '../common/slices/LanguageSlice';
import { LanguageService } from '../services';
import { ThunkDispatch } from '@reduxjs/toolkit';

export default function setLocaleFromUserInfo(
    data: UserInfo,
    currentLocale: string,
    allowedLocales: string[],
    dispatch: ThunkDispatch<any, any, any>,
) {
    if (data?.locale && data.locale !== currentLocale) {
        dispatch(LanguageSlice.actions.changeLocale(data.locale));
    } else if (
        allowedLocales?.length > 0 &&
        !allowedLocales.includes(currentLocale)
    ) {
        const defaultLocale = LanguageService.getDefaultLocale(allowedLocales);

        if (currentLocale !== defaultLocale) {
            dispatch(LanguageSlice.actions.changeLocale(defaultLocale));
        }
    }
}
